import React, { useEffect, useState } from 'react';
import { GithubIcon } from 'lucide-react';
import { profile } from '../data/profile';
const links = [{
  href: '#quien-soy',
  label: 'Quién soy'
}, {
  href: '#manifiesto',
  label: 'Manifiesto'
}, {
  href: '#filosofia',
  label: 'Filosofía'
}, {
  href: '#proyectos',
  label: 'Proyectos'
}, {
  href: '#presencia',
  label: 'Presencia'
}, {
  href: '#rumbo',
  label: 'Rumbo'
}];
export function Nav() {
  const [scrolled, setScrolled] = useState(false);
  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    onScroll();
    window.addEventListener('scroll', onScroll, {
      passive: true
    });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);
  return <header className="fixed inset-x-0 top-0 z-50 px-4 pt-4 sm:px-6" data-id="element-139" data-mp="1una5qo3ny5ar">
      <nav aria-label="Principal" className={`mx-auto flex max-w-6xl items-center justify-between rounded-full border px-5 py-3 backdrop-blur-md transition-[background-color,border-color] duration-200 ease-out ${scrolled ? 'border-teal-dim bg-void/85' : 'border-hairline bg-void/50'}`} data-id="element-140" data-mp="1yqoy8e8sge53">
        <a href="#top" className="font-mono text-sm font-bold tracking-tight text-ink-hi focus:outline-none focus-visible:ring-2 focus-visible:ring-teal" data-id="element-141" data-mp="1u3k594dtsp5g">
          <span className="text-teal" data-id="element-142" data-mp="1k77cc8q3ufbr">◆</span> SolarisPKN
        </a>

        <ul className="hidden items-center gap-1 lg:flex" data-id="element-143" data-mp="2hto7p8fa2iuv">
          {links.map(link => <li key={link.href} data-id="element-144" data-mp="2cuuqb4wve7pf">
              <a href={link.href} className="rounded-full px-3 py-1.5 font-mono text-[13px] text-ink-mid transition-colors duration-150 ease-out hover:bg-panelalt hover:text-ink-hi focus:outline-none focus-visible:ring-2 focus-visible:ring-teal" data-id="element-145" data-mp="2cvw3bexg549s">
                {link.label}
              </a>
            </li>)}
        </ul>

        <a href={profile.github} target="_blank" rel="noreferrer" className="flex items-center gap-2 rounded-full border border-hairline px-3.5 py-1.5 font-mono text-[13px] text-ink-hi transition-colors duration-150 ease-out hover:border-teal hover:text-teal focus:outline-none focus-visible:ring-2 focus-visible:ring-teal" data-id="element-146" data-mp="2vt71ew7cdrnn">
          <GithubIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-147" data-mp="p5ghp3j0zues" />
          GitHub
        </a>
      </nav>
    </header>;
}